import CurrentDetails from "./CurrentDetails";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div>
        <h1>React Weather app</h1>
      </div>
      <CurrentDetails />
      <br />
      <p>
        <a
          href="https://github.com/JulietBangay/react-weather-app"
          id="github-repository"
        >
          GitHub repository
        </a>
      </p>
    </div>
  );
}
